import { render, staticRenderFns } from "./SkeletonBag.vue?vue&type=template&id=10d57be2"
import script from "./SkeletonBag.vue?vue&type=script&lang=js"
export * from "./SkeletonBag.vue?vue&type=script&lang=js"
import style0 from "./SkeletonBag.vue?vue&type=style&index=0&id=10d57be2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports